// @ts-nocheck
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { laneData } from '../files-download/files-download.component';
import { TextareaComponent } from '../textarea/textarea.component';
import { InputLinkService } from './input-link.service';

@Component({
    selector: 'lbca-input-link',
    templateUrl: './input-link.component.html',
    imports: [TextareaComponent]
})
export class InputLinkComponent {
	private inputLinkService = inject(InputLinkService);

	@Input() lane!: laneData;
	@Output() audienceLink = new EventEmitter();

	public isDisabled: boolean = true;
	public statusLoader = false;

	@Input() set disabled(disabled) {
		this.isDisabled = disabled;
	}

	onchage(value: any) {
		if (this.lane) this.lane.audienceLink = value;
	}

	saveLink() {
		if (this.statusLoader) {
			return;
		}

		this.statusLoader = true;
		this.inputLinkService.updateAudience(this.lane).subscribe(
			(response) => {
				this.statusLoader = false;
			},
			(error) => (this.statusLoader = false),
		);
	}
}
